import React, { useState, useEffect } from "react";
import "./userListPanel.scss";
import type { UserListPanelModel } from "../../type/settings";


const UserListPanel: React.FC<UserListPanelModel> = ({ users, selectedUserId, onSelect }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const userId = parseInt(e.target.value);
    const selectedUser = users.find(user => user.iduser === userId);
    if (selectedUser) {
      onSelect(selectedUser);
    }
  };

  if (isMobile) {
    return (
      <div className="user-list-panel mobile">
        <h3>
          <i className="bi bi-people-fill me-2"></i>
          Select User
        </h3>
        <select
          id="user-select"
          className="form-select form-select-lg user-select"
          value={selectedUserId || ''}
          onChange={handleSelectChange}
        >
          <option value="" disabled>
            Choose a user...
          </option>
          {users.map((user) => (
            <option key={user.iduser} value={user.iduser}>
              {user.username} • {user.email}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div className="user-list-panel desktop">
      <h3>
        <i className="bi bi-people-fill me-2"></i>
        Users
      </h3>
      <ul>
        {users.map((user) => (
          <li
            key={user.iduser}
            className={user.iduser === selectedUserId ? "selected" : ""}
            onClick={() => onSelect(user)}
          >
            <div className="user-list-name">{user.username}</div>
            <div className="user-list-email">{user.email}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UserListPanel;